<template>
  <div>
    <div
      v-if="jobsStore.jobs && jobsStore.jobs.length > 0"
      ref="root"
      class="container"
    >
      <section :class="gridClass">
        <template v-for="job in jobsStore.jobs" :key="job?.JobId">
          <JobsBaseCard :job="job" :lang="jobsStore.lang" />
        </template>
      </section>
    </div>
    <span ref="target" itrospect-1></span>
    <BaseAlert
      v-if="
        !jobsStore.loading && (!jobsStore.jobs || jobsStore.jobs.length === 0)
      "
      :lang="jobsStore.lang"
    >
      <template #title>
        {{ LANG.noResults?.[jobsStore.lang] }}
      </template>
      {{ LANG.noResultsForSearchProps?.[jobsStore.lang] }}
    </BaseAlert>
  </div>
</template>

<script setup lang="ts">
import { LANG } from '~/config/lang';
import { useJobs } from '~/store/useJobs';
const jobsStore = useJobs();

const emits = defineEmits<{ loadMoreResults: [] }>();

const root = ref(null);
const target = ref(null);
const isVisible = ref(false);
const observer = ref();

const gridClass = computed(() =>
  jobsStore.jobs && jobsStore.jobs?.length < 3
    ? `justify-center grid grid-cols-${jobsStore.jobs?.length} gap-4`
    : 'grid xl:grid-cols-3 md:grid-cols-2 gap-4'
);

function observed(elements: any) {
  console.log('observed', elements);
  isVisible.value = elements.find(
    (e: IntersectionObserverEntry) =>
      e?.target?.hasAttribute('itrospect-1') && e?.intersectionRatio > 0
  );
}

function observe() {
  observer.value && target.value && observer.value.observe(target.value);
}
function unobserve() {
  observer.value && target.value && observer.value.unobserve(target.value);
}

onMounted(() => {
  observer.value = new IntersectionObserver(observed);
  observe();
});

watch(isVisible, (curr, prev) => {
  if (!prev && curr) {
    unobserve();
    jobsStore.endOfResults || emits('loadMoreResults');
    observe();
  }
});

onUnmounted(() => {
  observer.value.disconnect();
});
</script>

<style scoped></style>
